/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Company\CompanyList\CompanyList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday January 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday January 18th 2024 11:51:23 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
import TitlePage from "Content/HeadingPage/TitlePage/TitlePage";
import translator from "MultiLanguage/TranslationWrapper";
import Table from "Content/Table/Table";
import TableUtils from "Utils/TableFormat";
import { useState, MouseEvent, useMemo, useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import { CompanyDataType } from "Type/company.type";
import CompanyRow from "../CompanyRow/CompanyRow";
import ModalCompany from "Content/Modals/ModalCompany/ModalCompany";
import CompanyService from "Services/CompanyService/CompanyService";
import SearchByTerm from "Content/Search/SearchByTerm";

function CompanyList() {
    const loadData = useLoaderData() as CompanyDataType[];
    const keys = ["Name", "Siren", "Standard", "Address", "City", "PostalCode", "State", "Country", "Actions"];
    const translateKey = "table.headers.";
    const myRet = TableUtils.initFormatRowCreateHeader(keys, translateKey);
    const [showModalCompany, setShowModalCompany] = useState(false);
    const [data, setData] = useState<CompanyDataType[]>(loadData);
    const [result, setResult] = useState<{label: String, result: CompanyDataType}[]>([]);
    const [companyCreated, setCompanyCreated] = useState<CompanyDataType>();

    const openModalCreateCompany = (e: any) => {
        e.stopPropagation();
        setShowModalCompany(true);
    };

    const closeModalCreateCompany = (e: MouseEvent<HTMLElement>) => {
        setShowModalCompany(false);
    };

    useEffect(() => {
        if (result.length > 0)
            setData(result.map(v => v.result));
        else
            setData(loadData);
    }, [result]);

    useEffect(() => {
        if(companyCreated)
            myRows.unshift(<CompanyRow key={`${companyCreated.Name}`} {...companyCreated} />);
    }, [companyCreated]);

    const buildMyRows = (data: CompanyDataType[]) => {
        let myRows: JSX.Element[] = [];
        for (let i = 0; i < data.length; ++i)
            myRows.push(<CompanyRow key={`${data[i].Name}-${i}`} {...data[i]} />);
        return myRows;
    };

    const myRows = useMemo(() => {
        return buildMyRows(data as CompanyDataType[]);
    }, [data]);

    return(
        <div className="p-3">
            <SearchByTerm searchFunc={CompanyService.getCompanyBySearch} setResult={setResult} title={translator.decode("dynamic.company")} />
            <TitlePage title={translator.decode("dynamic.companies")} backLink={RouterPathResolver.pathHome.path} action={<button className="btn btn-primary" onClick={openModalCreateCompany}>{translator.decode("dynamic.create")}</button>}/>
            <Table cursor={false} pagination={false} rows={myRows} header={myRet.header} nbTotalElement={loadData.length} />
            <ModalCompany data={{}} updateCompany={setCompanyCreated} submitFunc={CompanyService.createCompany} title={translator.decode("dynamic.company")} show={showModalCompany} onClose={closeModalCreateCompany} closeModal={closeModalCreateCompany} />
        </div>
    )
};

export default CompanyList;
